import dayjs from "dayjs";

export default {
    data() {
        return {
            addFiles: [],
            files: [],
            rules: {
                required: v => !!v || this.$t('register-external-operator.field-required'),
                max50: v => v <= 50 || this.$t('register-external-operator.range-0-50'),
                max1000: v => v <= 1000 || this.$t('register-external-operator.range-0-1000'),
                max2000: v => v <= 2000 || this.$t('register-external-operator.range-0-2000'),
            }
        }
    },


    computed: {
        meterDeviceData() {
            return this.$parent.meterDeviceData
        },

        energyVatRate() {
            return this.meterDeviceData.refundVatRate
        },

        subscriptionVatRate() {
            return this.meterDeviceData.chargingVatRate
        },
    },

    watch: {
        addFiles() {
            if(this.addFiles?.length > 0) {
                const maxuplodableFiles = 5 - (this.addFiles.length + this.files.length)
                if(maxuplodableFiles < 0) {
                    this.$dialog.notify.warning(this.$t('register-external-operator.upload-invoice-max-files-reached'))
                }
                for(let file of this.addFiles) {
                    if(this.files.length < 5) {
                        this.files.push(file)
                    }
                }
                this.addFiles = []
            }
        },
    },

    methods: {
        computeKwhPrice({ consumption, amountIncludingVat }) {
            return consumption > 0 ? (amountIncludingVat ?? 0) / consumption : 0;
        },

        isKwhPriceValid(entry, min = 0.10, max = 0.50) {
            const price = this.computeKwhPrice(entry);
            return price === 0 || (price >= min && price <= max);
        },

        isAmountIncludingVatValid(entry, vatRate) {
            if (!entry?.amount)
                return true;
            const expected = entry.amount * (1 + vatRate / 100);
            const diffPct = Math.abs(expected - entry.amountIncludingVat) / expected * 100;
            return diffPct <= 1.5;
        },

        uploadFile(inputFileRefName) {
            this.$refs[inputFileRefName].$el.querySelector('input').click()
        },

        previewFile(file) {
            if(file) {
                window.open(URL.createObjectURL(file))
            }
        },

        allowedMonths(month) {
            return month <= dayjs().format('YYYY-MM') && month >= dayjs().subtract(3, 'year').format('YYYY-MM')
        },

        saveForm() {
            if(this.validate && !this.validate()) {
                return
            }
            if(!this.files.length > 0) {
                this.notifyError(this.$t('register-external-operator.upload-invoice-required'))
                return
            }
            if (this.$refs.form.validate()) {
                this.$parent.save(this.form, this.files)
            } else {
                this.notifyError(this.$t('register-external-operator.form-errors'))
            }
        },

        deleteFile(index) {
            this.files.splice(index, 1)
        }
    },


}